import { SplashScreen } from '@capacitor/splash-screen'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from '~/app'
import { initSentry } from '~/shared/lib/sentry'
import { InitYandexMetrika } from '~/shared/ui/YandexMetrika'
import { initPushNotifications } from './entities/Notifications'

initSentry()
setTimeout(SplashScreen.hide, 1000)
initPushNotifications()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <InitYandexMetrika />
    <App />
  </React.StrictMode>,
)
